import { loader } from 'graphql.macro';

import { appClient } from 'src/config/apollo';
import { CoachNode } from 'src/generated/webapp_gql';
import { ProviderType } from 'src/modules/user/models/user';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';

//Hack to refresh cache getMyProvidersQuery
const GET_MY_PROVIDERS_QUERY = loader('../documents/getMyProvidersQuery.graphql');
const GET_AVAILABLE_PROVIDERS_QUERY = loader('../documents/getAvailableProvidersQuery.graphql');

export class ProvidersService {
    constructor(private toastNotificationsService: ToastNotificationsService) {
        this.toastNotificationsService = toastNotificationsService;
    }

    public async fetchAvailableProviders(providerType: string): Promise<CoachNode[]> {
        try {
            // for coaches it's 11 because this query will also return already matched coaches. We want to show 9 coaches that are not matched with the user yet
            // so we have to fetch 2 more than that since it's the max number of coaches that user can be matched with right now
            // for therapists it's 10 because the max number of therapists they can be matched with is 1
            const pageSize = providerType === ProviderType.THERAPIST ? 10 : 11;
            const { data } = await appClient.query({
                query: GET_AVAILABLE_PROVIDERS_QUERY,
                variables: { providerType, pageSize, pageNumber: 1 },
                fetchPolicy: 'network-only',
            });

            const providers = data.coaches.map(provider => ({
                ...provider,
                // CC-614: getting rid of newline characters
                firstName: provider?.firstName.replace(/(\r\n|\n|\r|\\n)/gm, ''),
                lastName: provider?.lastName.replace(/(\r\n|\n|\r|\\n)/gm, ''),
            }));

            return providers;
        } catch (e) {
            this.toastNotificationsService.renderErrorToast('Could not fetch providers.');

            return [];
        }
    }

    public fetchMyProviders(memberUuid: string): Promise<CoachNode[]> {
        return appClient
            .query({
                query: GET_MY_PROVIDERS_QUERY,
                variables: { memberUuid },
                fetchPolicy: 'network-only',
            })
            .then(result => result.data.coachAssignments)
            .catch(() =>
                this.toastNotificationsService.renderErrorToast('Could not fetch providers.'),
            );
    }
}
